import { BaseComparison } from '../../../components/general/BaseComparison';
import { ComparisonType } from '../../../types/index';




export default function ComparisonSection(props: ComparisonType) {

    const leftItems = props.leftSide?.item ?? []
    const rightItems = props.rightSide?.item ?? []

    const leftLabel = props.leftSide?.label ?? ""
    const leftHeadline = props.leftSide?.headline ?? ""

    const rightLabel = props.rightSide?.label ?? ""
    const rightHeadline = props.rightSide?.headline ?? ""

    const ctaLabel = props.rightSide?.CTA?.label
    const ctaLink = props.rightSide?.CTA?.link


    return (
        <section className="py-20 px-4 w-full sm:px-8 xl:px-0">
            <div className="max-w-page mx-auto">
                <BaseComparison
                    variant={props.softwareComparisonTransparent ? "transparent-left" : "default"}
                    left={{
                        label: leftLabel,
                        labelColor: "secondary",
                        headline: leftHeadline,
                        items: leftItems.map(item => ({
                            text: item.text,
                            variant: item.positive ? "positive" : "negative"
                        })),
                    }}
                    right={{
                        label: rightLabel,
                        headline: rightHeadline,
                        items: rightItems.map(item => ({
                            text: item.text,
                            variant: item.positive ? "positive" : "negative"
                        })),
                        cta: ctaLabel && ctaLink ? { label: ctaLabel, url: ctaLink } : undefined,
                    }}
                />
            </div>
        </section>
    )
}

